import { productsSearched } from '@/rudder-typer';
import { PageSection } from '@/utils/analytics/PageSection';

export interface ProductSearched {
  pageSection?: PageSection<
    'Custom Snack Box Builder Search' | 'Custom Snack Box Subscription Portal' | 'Main Search Bar'
  >;
  query: string;
}

export function sendProductsSearched({ pageSection, query }: ProductSearched) {
  productsSearched({
    page_section: pageSection,
    query,
  });
}
